import React, { useEffect, useState } from 'react';
import Icon from './Icon';
import { useTheme } from '../context/ThemeContext';
import { scrollToId } from '../utils/scroll';
import { NAV_LINKS } from '../data/content';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id) => {
    scrollToId(id);
    setOpen(false);
  };

  return (
    <header className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <a href="#hero" className="logo" onClick={(e) => { e.preventDefault(); go('hero'); }}>
          <span className="logo-mark">BT</span>
          <span className="logo-text">Buildstrust<span>IT Consultants</span></span>
        </a>

        <nav className={`nav-links ${open ? 'open' : ''}`}>
          {NAV_LINKS.map((link) => (
            <button key={link.id} className="nav-link" onClick={() => go(link.id)}>
              {link.label}
            </button>
          ))}
          {/* <button className="nav-link mobile-only" onClick={() => go('contact')}>Contact</button>
          <button className="btn btn-primary btn-nav mobile-only" onClick={() => go('contact')}>
            Schedule a Consultation
          </button> */}
        </nav>

        <div className="nav-actions">
          <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle dark mode">
            <Icon name={theme === 'light' ? 'moon' : 'sun'} size={19} />
          </button>
          {/* <button className="btn btn-primary btn-nav desktop-only" onClick={() => go('contact')}>
            Schedule a Consultation
          </button> */}
          <button className="hamburger" onClick={() => setOpen((o) => !o)} aria-label="Menu">
            <Icon name={open ? 'close' : 'menu'} size={22} />
          </button>
        </div>
      </div>
    </header>
  );
}